import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';

export default class JobFullDetailsMainDetailsDriverBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  render() {
    let driverBlock;

    driverBlock = (
      <p className="alert alert-danger alert-in-map"
         onClick={() =>
           this.handleJobScheduling()
         }
      >
        <i className="fa fa-exclamation"></i> Driver not assigned yet.
      </p>
    );

    if (this.state.data.driver_id !== null &&
      this.state.data.driver !== null) {
      driverBlock = (<div>
        <p>
          <strong>Name: </strong>
          <a href={"/drivers/view/"+this.state.data.driver.id}>
            {this.state.data.driver.user.first_name}&nbsp;
            {this.state.data.driver.user.last_name}
          </a>
        </p>
        <p>
          <strong>Company: </strong>
          {((this.state.data.driver)&&(this.state.data.driver.company)&&(this.state.data.driver.company.name))?this.state.data.driver.company.name:''}
        </p>
        <p>
          <strong>Email: </strong>
          <a href={"mailto:"+this.state.data.driver.user.email}>
            {this.state.data.driver.user.email}
          </a>
        </p>
        <p>
          <strong>Telephone: </strong>
          {this.state.data.driver.contact_number}
        </p>

        <a href={"/drivers/view/"+this.state.data.driver.id}>
          <img src={"/user-images/"+this.state.data.driver.user.id}
               className="driver-block-image" />
        </a>
      </div>);
    }

    if (this.state.data.has_split_jobs === 1) {
      driverBlock = (
        <p className="alert alert-danger">
          <i className="fa fa-exclamation"></i>
          Driver cannot be assigned to a job that has been split.
        </p>
      );
    }

    return driverBlock;
  }
}